import { Box, Button, HStack, IconButton, Input, Text, VStack } from "@chakra-ui/react";
import { AddOutlined, Close, CloseOutlined } from "@mui/icons-material";
import React from "react";

const FileGroupsModal = ({ isOpen, onClose, isOpenAction, fileToDisplay, setFileToDisplay, groups, getGroups }) => {
    const [accessType, setAccessType] = React.useState(fileToDisplay?.shared_groups?.length > 0 ? "groups" : (fileToDisplay?.is_shared_with_org) ? "org" : "private");
    const [finalGroups, setFinalGroups] = React.useState(fileToDisplay?.shared_groups || []);
    const [newTagKey, setNewTagKey] = React.useState("");
    const [newTagValue, setNewTagValue] = React.useState("");
    const [allTags, setAllTags] = React.useState(fileToDisplay?.tags || []);

    const addTag = () => {
        if (newTagKey && newTagValue) {
            const newTag = {
                tag_key: newTagKey,
                tag_value: newTagValue,
            };

            setAllTags([...allTags, newTag]);
            setNewTagKey("");
            setNewTagValue("");
        }
    };

    const removeTag = (index) => {
        const updatedTags = allTags.filter((_, i) => i !== index);
        setAllTags(updatedTags);
    };

    React.useEffect(() => {
        if (fileToDisplay?.shared_groups?.length > 0) {
            setAccessType("groups");
            setFinalGroups(fileToDisplay.shared_groups);
            if (groups?.length == 0) {
                getGroups();
            }
        } else if (fileToDisplay?.is_shared_with_org) {
            setAccessType("org");
        } else {
            setAccessType("private");
        }

        if (fileToDisplay?.tags?.length > 0) {
            setAllTags(fileToDisplay.tags);
        }
    }, [fileToDisplay])

    if (!isOpen) return null;
    if (isOpenAction !== "file-groups") return null;

    // const triggerUploadFile = () => {
    //     if (!selectedFiles || selectedFiles.length === 0) {
    //         alert("Please select at least one file to upload");
    //         return;
    //     }
    //     const uploadFilesSequentially = async () => {
    //         for (const file of selectedFiles) {
    //         await handleUploadFile(file, accessType, finalGroups);
    //         }
    //     };

    //     uploadFilesSequentially().then(() => {
    //         setSelectedFiles([]);
    //         onClose();
    //     }).catch((error) => {
    //         console.error("Error uploading files:", error);
    //         alert("An error occurred while uploading files");
    //     });
    //     setSelectedFiles([]);
    //     onClose();
    // };

    return (
        <Box
            position="fixed"
            top="0"
            left="0"
            width="100vw"
            height="100vh"
            bg="rgba(0, 0, 0, 0.5)"
            display="flex"
            alignItems="center"
            justifyContent="center"
            // onDragOver={(e) => e.preventDefault()}
            // onDrop={(e) => {
            //     e.preventDefault();
            //     const files = Array.from(e.dataTransfer.files);
            //     setSelectedFiles(files);
            //     setIsDragging(false);
            // }}
        >
            <Box
                bg="white"
                p="24px"
                borderRadius="md"
                boxShadow="lg"
                width="400px"
            >
                <Text fontSize="lg" fontWeight="bold" mb="16px">File Info</Text>
                <Box mb="16px" display="flex" alignItems="center" justifyContent="space-between">
                    <Box width={"100%"}>
                        <Text fontSize="sm" fontWeight="bold">File Name</Text>
                        <HStack width={"100%"} justifyContent="space-between">
                            <Text fontSize="sm" color="gray.600" w={`calc(100% - 40px)`}>
                                {fileToDisplay?.name}
                            </Text>
                        </HStack>
                    </Box>
                </Box>
                <Box>
                    <Text fontSize="sm" fontWeight="bold" mb="8px">Access Type</Text>
                    <HStack mb={"8px"}>
                        <label>
                            <input
                                type="radio"
                                name="accessType"
                                value="org"
                                checked={accessType === "org"}
                                onChange={() => setAccessType("org")}
                                style={{ marginRight: "8px" }}
                            />
                            Organisation
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="accessType"
                                value="private"
                                checked={accessType === "private"}
                                onChange={() => setAccessType("private")}
                                style={{ marginRight: "8px" }}
                            />
                            Private
                        </label>
                        {
                            groups.length > 0 ? (
                                <label>
                                    <input
                                        type="radio"
                                        name="accessType"
                                        value="groups"
                                        checked={accessType === "groups"}
                                        onChange={() => setAccessType("groups")}
                                        style={{ marginRight: "8px" }}
                                    />
                                    Share
                                </label>
                            ) : (
                                <label>
                                    <input
                                        type="radio"
                                        name="accessType"
                                        value="groups"
                                        checked={accessType === "groups"}
                                        onChange={() => {
                                            getGroups();
                                            setAccessType("groups");
                                        }}
                                        style={{ marginRight: "8px" }}
                                    />
                                    Share
                                </label>
                                // <HStack
                                //     onClick={() => {
                                //         getGroups();
                                //         setAccessType("groups");
                                //     }}
                                //     border={"1px solid #ccc"}
                                //     height={"32px"}
                                //     minH={"unset"}
                                //     spacing={0}
                                //     cursor={"pointer"}
                                // >
                                //     <IconButton
                                //         sx={{
                                //             paddingX:0,
                                //             paddingY:0,
                                //             bgColor: "transparent",
                                //             "&:hover":{backgroundColor: "transparent"},
                                //             minHeight: "unset",
                                //             minWidth: "unset",
                                //             height: "22px",
                                //             width: "22px",
                                //             cursor: "default",
                                //         }}
                                //     >
                                //         <ArrowOutwardOutlined
                                //             sx={{ padding:0, fontSize: 18, color: "#5d5d5d", bgColor: "transparent",
                                //                 minHeight: "unset",
                                //                 minWidth: "unset",
                                //                 height: "18px",
                                //                 width: "18px", 
                                //             }}
                                //         />
                                //     </IconButton>
                                //     <Text
                                //         fontSize="sm" 
                                //         color="#1d1d1d" 
                                //         fontWeight={"semibold"}
                                //         marginX={"4px"}
                                //     >
                                //         Click to Share
                                //     </Text>
                                // </HStack>
                            )
                        }
                    </HStack>
                    {
                        accessType === "groups" && groups.length > 0 && (
                            <NewAndExistingGroups groups={groups} finalGroups={fileToDisplay?.shared_groups}/>
                        )
                    }
                </Box>
                <Box>
                    <Text fontSize="sm" fontWeight="bold" mb="8px">Tags</Text>
                    <HStack mb={"8px"} width={"100%"} justifyContent={"space-between"}>
                        <HStack width={"80%"}>
                            <Input
                                w={"35%"}
                                placeholder="Type"
                                value={newTagKey}
                                onChange={(e) => setNewTagKey(e.target.value)}
                            />
                            <Input
                                w={"65%"}
                                placeholder="Value"
                                value={newTagValue}
                                onChange={(e) => setNewTagValue(e.target.value)}
                            />
                        </HStack>
                        <Button width={"20%"} minW={"70px"} paddingx={"4px"}
                            onClick={() => addTag()}
                        >
                            <IconButton
                                sx={{
                                    paddingX:0,
                                    paddingY:0,
                                    backgroundColor:"transparent",
                                    "&:hover":{backgroundColor:"transparent"},
                                    width: "22px",
                                    height: "22px",
                                    minHeight: "unset",
                                    minWidth: "unset",
                                }}
                            >
                                <AddOutlined
                                    sx={{ padding:0, fontSize: 18, color: "#5d5d5d", bgColor: "transparent" }}
                                />
                            </IconButton>
                            <Text>
                                Add
                            </Text>
                        </Button>
                    </HStack>
                    {
                        allTags?.length > 0 && (
                            <Box mb="4" w={"100%"}>
                                <Text fontSize="14px" fontWeight={"semibold"} color="#1d1d1d">
                                    Applied Tags:
                                </Text>
                                <HStack wrap="wrap" spacing="4px" maxH={"200px"} overflowY={"scroll"} data-scrollable="true">
                                    {allTags.map((tag, index) => (
                                        <Box
                                            key={index}
                                            p="2"
                                            border="1px solid #e5e5e5"
                                            borderRadius="4px"
                                            bg="#f9f9f9"
                                            display="flex"
                                            alignItems="center"
                                        >
                                            <Text fontSize="14px" color="#1d1d1d">
                                                {tag.tag_key}: {tag.tag_value}
                                            </Text>
                                            <IconButton
                                                size="xs"
                                                sx={{
                                                    paddingX:0,
                                                    paddingY:0,
                                                    backgroundColor:"transparent",
                                                    "&:hover":{backgroundColor:"transparent"}
                                                }}
                                                icon={<Close fontSize="small" />}
                                                onClick={() => removeTag(index)}
                                            />
                                        </Box>
                                    ))}
                                </HStack>
                            </Box>
                        )
                    }
                    
                </Box>
                <Box display="flex" justifyContent="flex-end" gap="8px">
                    <Button onClick={onClose}>Cancel</Button>
                    {/* <Button
                        color={"white"}
                        bg={"#2584FD"}
                        _hover={{
                            background: "#2584FD",
                            color: "white",
                        }}
                        onClick={triggerUploadFile}
                    >Upload</Button> */}
                </Box>
            </Box>
        </Box>
    );
};

const NewAndExistingGroups = ({
    groups,
    finalGroups,
    setFinalGroups,
}) => {
    const [searchValue, setSearchValue] = React.useState("");
    const [filteredGroups, setFilteredGroups] = React.useState([]);
    const [remainingGroups, setRemainingGroups] = React.useState(groups);

    return (
        <>
            <HStack
                alignItems="center"
                spacing={1}
                marginBottom={"5px"}
            >
                <Text fontSize="14px" fontWeight={"semibold"} color="#1d1d1d" lineHeight={"22px"}>
                    Share With
                </Text>
            </HStack>
            <Box mb="4" w={"90%"}>
                <Input
                    placeholder="Type an email or group name"
                    onChange={(e) => {
                        const value = e.target.value.toLowerCase();
                        setSearchValue(value);
                        const tempFilteredGroups = remainingGroups.filter(group => 
                            (group.name.toLowerCase().includes(value))
                        );
                        setFilteredGroups(tempFilteredGroups);
                    }}
                />
                {searchValue?.length > 0 && filteredGroups?.length > 0 && (
                    <Box
                        mt="2"
                        border="1px solid #e5e5e5"
                        borderRadius="4px"
                        maxHeight="150px"
                        overflowY="scroll"
                        data-scrollable="true"
                        bg="white"
                    >
                        {filteredGroups.map((group, index) => (
                            <Box
                                key={index}
                                p="2"
                                _hover={{ bg: "#f0f0f0", cursor: "pointer" }}
                                onClick={() => {
                                    setFinalGroups([...finalGroups, group]);
                                    setRemainingGroups(remainingGroups.filter(g => g.id !== group.id));
                                }}
                            >
                                <VStack
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    width="100%"
                                    spacing={0}
                                >
                                    <Text fontSize="14px" color="#1d1d1d">
                                        {group.name}
                                    </Text>
                                    {
                                        group.type != "private" && (
                                            <Text fontSize="12px" color="#7d7d7d">
                                                {group.description}
                                            </Text>                                                
                                        )
                                    }
                                </VStack>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
            {
                finalGroups?.length > 0 && (
                    <Box mb="4" w={"100%"}>
                        <Text fontSize="14px" fontWeight={"semibold"} color="#1d1d1d">
                            Sharing with:
                        </Text>
                        <HStack wrap="wrap" spacing="4px" maxH={"200px"} overflowY={"scroll"} data-scrollable="true">
                            {finalGroups.map((group, index) => (
                                <Box
                                    key={index}
                                    p="2"
                                    border="1px solid #e5e5e5"
                                    borderRadius="4px"
                                    bg="#f9f9f9"
                                    display="flex"
                                    alignItems="center"
                                >

                                    <VStack
                                        alignItems="flex-start"
                                        justifyContent="flex-start"
                                        width="100%"
                                        spacing={0}
                                    >
                                        <Text fontSize="14px" color="#1d1d1d">
                                            {group.name}
                                        </Text>
                                        {
                                            group.type != "private" && (
                                                <Text fontSize="12px" color="#7d7d7d">
                                                    {group.description}
                                                </Text>                                                
                                            )
                                        }                                               
                                    </VStack>
                                    <IconButton
                                        size="xs"
                                        sx={{
                                            paddingX:0,
                                            paddingY:0,
                                            backgroundColor:"transparent",
                                            "&:hover":{backgroundColor:"transparent"}
                                        }}
                                        icon={<Close fontSize="small" />}
                                        onClick={() => {
                                            setFinalGroups(finalGroups.filter(g => g.id !== group.id));
                                            setRemainingGroups([...remainingGroups, group]);
                                        }}
                                    />
                                </Box>
                            ))}
                        </HStack>
                    </Box>
                )
            }
        </>
    )
}

export default FileGroupsModal;